import Vue from 'vue';

import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);

/*
"vue2-editor": "^2.10.3",
*/